/* eslint class-methods-use-this: 0 */
import moment from 'moment';

import TettraResource from './TettraResourceAbstractSchema';
import { ICON, RESOURCE_TYPE } from '../utilities/CONSTANTS';
import { FONT_ICON } from '../tettra-editor/utilities/CONSTANTS';
import { getApiNotionSearchUrl } from '../utilities/urlHelper';

class NotionPage extends TettraResource {
    constructor(data) {
        super(data);
        this.data = this.constructor.transformData(data);
        this.id = this.data.id;
        this.type = RESOURCE_TYPE.NOTION_PAGE;
    }

    static transformData(data) {
        const {
            id,
            last_edited_time: last_updated,
            properties,
            url,
        } = data;
        const title = properties.title?.title?.[0]?.plain_text ?? 'Untitled';

        return ({
            id, last_updated, url, title,
        });
    }

    getId() {
        return this.id;
    }

    getTitle() {
        return this.data.title;
    }

    getSubtitle() {
        // Handle bug with Notion api that returns date UTC 0 for some docs
        const notionDate = moment(this.data.last_updated);
        if (notionDate.isSame(moment.utc(0), 'year')) {
            return '';
        }

        return notionDate.fromNow();
    }

    getIcon() {
        return ICON.NOTION;
    }

    getUrl() {
        return this.data.url;
    }

    getEntityData() {
        const referenceType = RESOURCE_TYPE.NOTION_PAGE;
        const {
            id, title, url, last_updated,
        } = this.data;

        return ({
            referenceType,
            title,
            url,
            id,
            metadata: {
                last_updated,
            },
        });
    }

    getFontIcon() {
        return FONT_ICON.NOTION;
    }

    getCustomClass() {
        return 'notion';
    }

    isInternal() {
        return false;
    }

    static FromEntityData({
        id, title, url, metadata,
    }) {
        const properties = {
            title: {
                title: [{
                    plain_text: title,
                }],
            },
        };
        return new NotionPage({
            id,
            url,
            last_edited_time: metadata.last_updated,
            properties,
        });
    }

    static Search(searchQuery, maxSuggestions = 10) {
        const url = getApiNotionSearchUrl(window.userId, searchQuery, maxSuggestions);

        return new Promise((resolve, reject) => {
            $.get(url)
                .then(({ pages }) => {
                    resolve(pages.map((page) => new NotionPage(page)));
                })
                .catch(reject);
        });
    }
}

export default NotionPage;
